import React, {FC, Suspense, useMemo} from 'react';

import {SettingsCircleUrl} from '../../models/url/settingsUrlModel';
import {useFetchCircle} from '../fetchers/circles';
import {CircleEditor} from './circleEditor';
import {CircleEditorSkeleton} from './circleEditorSkeleton';

/*
 * Props.
 */

interface CircleEditorWrapperProps {
  url: SettingsCircleUrl;
}

interface CircleEditorEditProps {
  circleId: number;
}

/*
 * Component.
 */

export const CircleEditorWrapper: FC<CircleEditorWrapperProps> = (props) => {
  const {url} = props;

  const editor = useMemo(() => {
    if (url.circleId) {
      return <CircleEditorEdit circleId={url.circleId} />;
    }

    return <CircleEditor />;
  }, [url.circleId]);

  return (
    <Suspense fallback={<CircleEditorSkeleton isEditing={url.circleId !== undefined} />}>{editor}</Suspense>
  );
};

const CircleEditorEdit: FC<CircleEditorEditProps> = (props) => {
  const {circleId} = props;
  const {circle} = useFetchCircle(circleId, {suspense: true});

  if (!circle) {
    return null;
  }

  return <CircleEditor circle={circle} />;
};
